module.exports = __webpack_public_path__ + "assets/img/4.dec75734.jpg";